// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.signing.LeasingUserSigningWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { LeaseArtifactType, MarkAsSignedRequestDto, WhoHasSignedWebApiResponseDto } from '../..';

interface WhoHasSignedParams {
  leaseArtifactId: number;
  leaseArtifactType: LeaseArtifactType;
}

export const LeasingUserSigningWebApiHandler_markAsSigned_Path = '/api/web/v1/signing/markAsSigned';

/**
 * marks the lease as signed for user
 */
export const LeasingUserSigningWebApiHandler_markAsSigned = (
  postData: MarkAsSignedRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, MarkAsSignedRequestDto, void>(
    {
      endpoint: LeasingUserSigningWebApiHandler_markAsSigned_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const LeasingUserSigningWebApiHandler_whoHasSigned_Path = '/api/web/v1/signing/whoHasSigned';

/**
 * get list of users for signing
 */
export const LeasingUserSigningWebApiHandler_whoHasSigned = (getParams: WhoHasSignedParams, client = getClient()) => {
  return httpFrontEndRequest<WhoHasSignedParams, never, WhoHasSignedWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: LeasingUserSigningWebApiHandler_whoHasSigned_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
